import Api from './api';

const pricePlansListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/plans', {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createPricePlanRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/plans/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deletePricePlanRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/plan/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}

const updatePricePlanRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/plan/' + data.id, data.query, { headers: { Authorization: 'Bearer ' + access_token } })
}


export default { pricePlansListRequest, createPricePlanRequest, deletePricePlanRequest, updatePricePlanRequest }



// WEBPACK FOOTER //
// ./src/api/apiPricePlans.js